import { render, staticRenderFns } from "./Hour24List.vue?vue&type=template&id=06802947&"
import script from "./Hour24List.vue?vue&type=script&lang=ts&"
export * from "./Hour24List.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports